<template>
  <div class="text_wrap">
    <div>
      <span>{{ props.item.opUser }}创建了群聊</span>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  item: Object,
});
</script>
<style scoped>
.text_wrap {
  display: flex;
  justify-content: center;
}
span {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}
</style>
